import type { JSX } from "react";
import { useLocation } from "react-router-dom";
import { GlobalStatusBar } from "./GlobalStatusBar";

export function AdaptiveStatusBar(): JSX.Element {
  const location = useLocation();
  const authRoute =
    location.pathname === "/login" || location.pathname === "/signup";
  return <GlobalStatusBar variant={authRoute ? "auth" : "app"} />;
}
